import React , {Component} from 'react';
import store from '../../store';
import {Link} from 'react-router-dom';
import { withRouter } from "react-router-dom";


class ReporteTemplate extends Component{
	
	
	
	constructor(props){
		
		super(props);
		this.state={
			
				labels:[],
				data:[],
				tipo_reporte:''
			
		}
	
		this.renderContent=this.renderContent.bind(this);
		this.makeRows=this.makeRows.bind(this);
		this.makeHeaders=this.makeHeaders.bind(this);
		this.handleOnClick=this.handleOnClick.bind(this);
		this.comprobacion=this.comprobacion.bind(this);
		this.imprimir=this.imprimir.bind(this);

		store.subscribe(()=>{
			
			
			this.setState({
				
				labels:store.getState().labels_report,
				data:store.getState().data_report,
				tipo_reporte:store.getState().tipo_reporte
				
				
			})
			
		});
		
		
		
	}
	
	renderContent(){
		
		
		
	}
	
	componentDidMount(){
		
		if(store.getState().data_report.length!==0){
			
			window.print();
		}
	
	}
	
	makeHeaders(x){
		
		return(
				
					<th>{x}</th>
				
		);
		
	}
	
	
	makeRows(x){
			

		if(store.getState().tipo_reporte==='viajes_usuarios'){
		
			return (
			
				<tr>
					<td>{x.cliente}</td>
					<td>{x.empresa}</td>
					<td>{x.fechaBajada}</td>
					<td>{x.pago}</td>
					<td>{x.total}</td>
					<td>{x.lugar}</td>
				</tr>
			);
			
		}
		else if(store.getState().tipo_reporte==='viajes_conductor'){
			
			return(
				<tr>
					<td>{x.empleado}</td>
					<td>{x.fecha}</td>
					<td>{x.total}</td>
					<td>{x.lugar}</td>
					<td>{x.socio}</td>
				</tr>
			
			);
					
		}		
		else if(store.getState().tipo_reporte==='ganancia_socio'){
			
	
			
			return(
				
				<tr>
					<td>{x.socio}</td>
					<td>{x.total}</td>
				
				</tr>
			
			
			);
			
			
		}
		else if(store.getState().tipo_reporte==='reporte_conductores'){
	
			
	
			
			return(
					<tr>
						<td>{x.nombre}</td>
						<td>{x.dui}</td>
						<td>{x.licencia}</td>					
						<td>{x.socio}</td>						
						<td>{x.estado}</td>						
						<td>{x.vehiculo}</td>						
					
					</tr>
			
			);
			
		}
		else if(store.getState().tipo_reporte==='reporte_vehiculos'){
			
			return(
					<tr>
						<td>{x.marca}</td>
						<td>{x.modelo}</td>
						<td>{x.placa}</td>
						<td>{x.estado}</td>
						<td>{x.socio}</td>
						<td>{x.anio}</td>
						<td>{x.base}</td>
						<td>{x.tipo_vehiculo}</td>
						
					</tr>					
			)
			
		}
		else if(store.getState().tipo_reporte==='reporte_socios'){
			
			
			return(
					<tr>
							<td>{x.nombre}</td>
							<td>{x.apellido}</td>
							<td>{x.estado}</td>
							<td>{x.correo}</td>
					
					
					</tr>
			
			)
			
		}
		else if(store.getState().tipo_reporte==='reporte_new'){
		

			return(
				<tr>
						<td>{x.nombre_conductor}</td>
						<td>{x.unidad}</td>
						<td>{x.cant_pasajeros}</td>
						<td>{x.velocidad}</td>
						<td>{x.ruta}</td>
						<td>{x.placa}</td>
						<td>{x.hora_i}</td>
						<td>{x.hora_f}</td>
				
				
				</tr>
		
			
			)
		}
		
		
	}
	
	
	comprobacion(){
		
		if(store.getState().data_report.length===0){
			
			this.props.history.push('/reportes');
		}
		
	}
	
	
	handleOnClick(){
		
		store.dispatch({
			
			type: "STATE_REPORT",
			labels_report:[],
			data_report:[],
			tipo_reporte:''
		})

			
	}
	
	
	imprimir(){
		
		window.print();
		
		
	}
	
	
	render(){
		
		return(
		
			<div className="reporte_template container">			
			
				<Link to="/reportes" className="links" onClick={this.handleOnClick} >Volver a Reportes</Link>
				
				
				{this.comprobacion()}
				<table className="table table-hover table-report">
					
					<tr>
					{store.getState().labels_report.map(this.makeHeaders)}
					</tr>
					{store.getState().data_report.map(this.makeRows)}
										
				</table>			
				
				
		
				
			</div>
		
			
		);

	}
	
	
}
1
export default  withRouter(ReporteTemplate);


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteTemplate.jsx